import simpleModal from "../libs/simpleModal";
const baseurl = managementUrl

const getDesktopIframe = function () {
    let url = `${baseurl}/search/${community.organization_id}?communityId=${cid}`
    if (!window.user.isGuest) {
        url += '&token=' + window.user.token
    }
    // url = 'https://localhost/test-frame.php';
    return `<iframe width="1400" height="600" title="W3Schools Free Online Web Tutorials" src="${url}"></iframe>`
}

export default context => {
    $('#AISearch', context).on('click', e => {
        const modal = new simpleModal({
            id: 'AISearchModal',
            header: false,
            content: getDesktopIframe(),
        })
        modal.show()
        const listener = function(e) {
            console.debug(e)
            if (e.origin !== baseurl) {
                console.warn("origin mismatch: " + e.origin)
                return
            }
            try {
                if (e.data.sender === 'assistant-ai/login-signup') {
                    modal.hide()
                    window.open(e.data.message.communityHomeUrl + '?act=auth')
                } else if (e.data.sender === 'assistant-ai/event-search-card') {
                    window.open(e.data.message.resourceUrl)
                }
            } catch (e) {
                console.warn(e)
            }
        }
        window.addEventListener('message', listener, false);
        modal.$.on('closed.cc.modal', function () {
            window.removeEventListener('message', listener);
        })
        return false
    })

    $('#mobileProfileAiButton', context).on('click', (e) => {
        let url = `${baseurl}/search.m/${community.organization_id}?communityId=${cid}`
        if (!window.user.isGuest) {
            url += '&token=' + window.user.token
        }
        window.open(url, '_self')
        return false
    })
}
